var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 36.02,
    viewBox: "0 0 154 36.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4820",
    "data-name": "Group 4820",
    transform: "translate(-721 -383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    transform: "translate(721 383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7828",
    "data-name": "Path 7828",
    d: "M1,102.9a1.065,1.065,0,0,0-1,1.119v5.6a1.065,1.065,0,0,0,1,1.12,1.065,1.065,0,0,0,1-1.12v-5.6A1.064,1.064,0,0,0,1,102.9Zm0,0",
    transform: "translate(0 -89.258)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7829",
    "data-name": "Path 7829",
    d: "M35.156,74.941a1.065,1.065,0,0,0-1,1.12v15.5a1.006,1.006,0,1,0,2,0v-15.5A1.065,1.065,0,0,0,35.156,74.941Zm0,0",
    transform: "translate(-30.156 -65.944)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830",
    "data-name": "Path 7830",
    d: "M69.266,27.8a.955.955,0,0,0-1,.9V53.961a1.005,1.005,0,0,0,2,0V28.7A.955.955,0,0,0,69.266,27.8Zm0,0",
    transform: "translate(-60.266 -23.322)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831",
    "data-name": "Path 7831",
    d: "M103.4,61.934a1.065,1.065,0,0,0-1,1.12V82.088a1.006,1.006,0,1,0,2,0V63.054A1.065,1.065,0,0,0,103.4,61.934Zm0,0",
    transform: "translate(-90.399 -54.949)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832",
    "data-name": "Path 7832",
    d: "M206.469,45.406a.935.935,0,0,0-1,.853v19.2a1.013,1.013,0,0,0,2,0V46.26A.936.936,0,0,0,206.469,45.406Zm0,0",
    transform: "translate(-181.469 -38.039)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833",
    "data-name": "Path 7833",
    d: "M274.067,55.105a.925.925,0,0,0-1,.823V72.387a1.019,1.019,0,0,0,2,0V55.929A.924.924,0,0,0,274.067,55.105Zm0,0",
    transform: "translate(-241.067 -46.148)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834",
    "data-name": "Path 7834",
    d: "M308.2,89.238a1.066,1.066,0,0,0-1,1.12v11.2a1.006,1.006,0,1,0,2,0v-11.2A1.065,1.065,0,0,0,308.2,89.238Zm0,0",
    transform: "translate(-271.199 -77.947)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835",
    "data-name": "Path 7835",
    d: "M239.934.492a.975.975,0,0,0-1,.948V35.564a1,1,0,0,0,2,0V1.44a.975.975,0,0,0-1-.948Zm0,0",
    transform: "translate(-210.934 -0.492)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836",
    "data-name": "Path 7836",
    d: "M137.534,109.719a1.065,1.065,0,0,0-1,1.12v4.479a1.006,1.006,0,1,0,2,0v-4.479A1.066,1.066,0,0,0,137.534,109.719Zm0,0",
    transform: "translate(-120.535 -95.068)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837",
    "data-name": "Path 7837",
    d: "M342.332,107.434a1.065,1.065,0,0,0-1,1.119V113.4a1.006,1.006,0,1,0,2,0v-4.845A1.065,1.065,0,0,0,342.332,107.434Zm0,0",
    transform: "translate(-301.332 -93.123)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838",
    "data-name": "Path 7838",
    d: "M171.024,94.418a1.065,1.065,0,0,0-1,1.119v9.115a1.006,1.006,0,1,0,2,0V95.537A1.064,1.064,0,0,0,171.024,94.418Zm0,0",
    transform: "translate(-150.024 -82.237)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440",
    transform: "translate(765 383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7829-2",
    "data-name": "Path 7829",
    d: "M35.156,74.941a1.065,1.065,0,0,0-1,1.12v15.5a1.006,1.006,0,1,0,2,0v-15.5A1.065,1.065,0,0,0,35.156,74.941Zm0,0",
    transform: "translate(-34.156 -65.944)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830-2",
    "data-name": "Path 7830",
    d: "M69.266,27.8a.955.955,0,0,0-1,.9V53.961a1.005,1.005,0,0,0,2,0V28.7A.955.955,0,0,0,69.266,27.8Zm0,0",
    transform: "translate(-64.266 -23.322)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831-2",
    "data-name": "Path 7831",
    d: "M103.4,61.934a1.065,1.065,0,0,0-1,1.12V82.088a1.006,1.006,0,1,0,2,0V63.054A1.065,1.065,0,0,0,103.4,61.934Zm0,0",
    transform: "translate(-94.399 -54.949)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832-2",
    "data-name": "Path 7832",
    d: "M206.469,45.406a.935.935,0,0,0-1,.853v19.2a1.013,1.013,0,0,0,2,0V46.26A.936.936,0,0,0,206.469,45.406Zm0,0",
    transform: "translate(-185.469 -38.039)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833-2",
    "data-name": "Path 7833",
    d: "M274.067,55.105a.925.925,0,0,0-1,.823V72.387a1.019,1.019,0,0,0,2,0V55.929A.924.924,0,0,0,274.067,55.105Zm0,0",
    transform: "translate(-245.067 -46.148)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834-2",
    "data-name": "Path 7834",
    d: "M308.2,89.238a1.066,1.066,0,0,0-1,1.12v11.2a1.006,1.006,0,1,0,2,0v-11.2A1.065,1.065,0,0,0,308.2,89.238Zm0,0",
    transform: "translate(-275.199 -77.947)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835-2",
    "data-name": "Path 7835",
    d: "M239.934.492a.975.975,0,0,0-1,.948V35.564a1,1,0,0,0,2,0V1.44a.975.975,0,0,0-1-.948Zm0,0",
    transform: "translate(-214.934 -0.492)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836-2",
    "data-name": "Path 7836",
    d: "M137.534,109.719a1.065,1.065,0,0,0-1,1.12v4.479a1.006,1.006,0,1,0,2,0v-4.479A1.066,1.066,0,0,0,137.534,109.719Zm0,0",
    transform: "translate(-124.535 -95.068)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837-2",
    "data-name": "Path 7837",
    d: "M342.332,107.434a1.065,1.065,0,0,0-1,1.119V113.4a1.006,1.006,0,1,0,2,0v-4.845A1.065,1.065,0,0,0,342.332,107.434Zm0,0",
    transform: "translate(-305.332 -93.123)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838-2",
    "data-name": "Path 7838",
    d: "M171.024,94.418a1.065,1.065,0,0,0-1,1.119v9.115a1.006,1.006,0,1,0,2,0V95.537A1.064,1.064,0,0,0,171.024,94.418Zm0,0",
    transform: "translate(-154.024 -82.237)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441",
    transform: "translate(805 383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7829-3",
    "data-name": "Path 7829",
    d: "M35.156,74.941a1.065,1.065,0,0,0-1,1.12v15.5a1.006,1.006,0,1,0,2,0v-15.5A1.065,1.065,0,0,0,35.156,74.941Zm0,0",
    transform: "translate(-34.156 -65.944)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830-3",
    "data-name": "Path 7830",
    d: "M69.266,27.8a.955.955,0,0,0-1,.9V53.961a1.005,1.005,0,0,0,2,0V28.7A.955.955,0,0,0,69.266,27.8Zm0,0",
    transform: "translate(-64.266 -23.322)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831-3",
    "data-name": "Path 7831",
    d: "M103.4,61.934a1.065,1.065,0,0,0-1,1.12V82.088a1.006,1.006,0,1,0,2,0V63.054A1.065,1.065,0,0,0,103.4,61.934Zm0,0",
    transform: "translate(-94.399 -54.949)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832-3",
    "data-name": "Path 7832",
    d: "M206.469,45.406a.935.935,0,0,0-1,.853v19.2a1.013,1.013,0,0,0,2,0V46.26A.936.936,0,0,0,206.469,45.406Zm0,0",
    transform: "translate(-185.469 -38.039)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7833-3",
    "data-name": "Path 7833",
    d: "M274.067,55.105a.925.925,0,0,0-1,.823V72.387a1.019,1.019,0,0,0,2,0V55.929A.924.924,0,0,0,274.067,55.105Zm0,0",
    transform: "translate(-245.067 -46.148)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834-3",
    "data-name": "Path 7834",
    d: "M308.2,89.238a1.066,1.066,0,0,0-1,1.12v11.2a1.006,1.006,0,1,0,2,0v-11.2A1.065,1.065,0,0,0,308.2,89.238Zm0,0",
    transform: "translate(-275.199 -77.947)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7835-3",
    "data-name": "Path 7835",
    d: "M239.934.492a.975.975,0,0,0-1,.948V35.564a1,1,0,0,0,2,0V1.44a.975.975,0,0,0-1-.948Zm0,0",
    transform: "translate(-214.934 -0.492)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836-3",
    "data-name": "Path 7836",
    d: "M137.534,109.719a1.065,1.065,0,0,0-1,1.12v4.479a1.006,1.006,0,1,0,2,0v-4.479A1.066,1.066,0,0,0,137.534,109.719Zm0,0",
    transform: "translate(-124.535 -95.068)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837-3",
    "data-name": "Path 7837",
    d: "M342.332,107.434a1.065,1.065,0,0,0-1,1.119V113.4a1.006,1.006,0,1,0,2,0v-4.845A1.065,1.065,0,0,0,342.332,107.434Zm0,0",
    transform: "translate(-305.332 -93.123)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838-3",
    "data-name": "Path 7838",
    d: "M171.024,94.418a1.065,1.065,0,0,0-1,1.119v9.115a1.006,1.006,0,1,0,2,0V95.537A1.064,1.064,0,0,0,171.024,94.418Zm0,0",
    transform: "translate(-154.024 -82.237)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443",
    transform: "translate(845 387.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7829-4",
    "data-name": "Path 7829",
    d: "M35.156,74.941c-.552,0-1,.317-1,.708v9.8c0,.391.448.708,1,.708s1-.317,1-.708v-9.8C36.156,75.258,35.708,74.941,35.156,74.941Zm0,0",
    transform: "translate(-34.156 -67.209)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7830-4",
    "data-name": "Path 7830",
    d: "M69.266,27.8a.955.955,0,0,0-1,.9V53.961a1.005,1.005,0,0,0,2,0V28.7A.955.955,0,0,0,69.266,27.8Zm0,0",
    transform: "translate(-64.266 -27.801)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7831-4",
    "data-name": "Path 7831",
    d: "M103.4,61.934a1.065,1.065,0,0,0-1,1.12V82.088a1.006,1.006,0,1,0,2,0V63.054A1.065,1.065,0,0,0,103.4,61.934Zm0,0",
    transform: "translate(-94.399 -59.303)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7832-4",
    "data-name": "Path 7832",
    d: "M206.469,45.406a.935.935,0,0,0-1,.853v19.2a1.013,1.013,0,0,0,2,0V46.26A.936.936,0,0,0,206.469,45.406Zm0,0",
    transform: "translate(-185.469 -42.518)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7834-4",
    "data-name": "Path 7834",
    d: "M308.2,89.238a1.066,1.066,0,0,0-1,1.12v11.2a1.006,1.006,0,1,0,2,0v-11.2A1.065,1.065,0,0,0,308.2,89.238Zm0,0",
    transform: "translate(-283.199 -82.426)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7836-4",
    "data-name": "Path 7836",
    d: "M137.534,109.719a1.065,1.065,0,0,0-1,1.12v4.479a1.006,1.006,0,1,0,2,0v-4.479A1.066,1.066,0,0,0,137.534,109.719Zm0,0",
    transform: "translate(-124.535 -99.547)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7837-4",
    "data-name": "Path 7837",
    d: "M342.332,107.434a1.065,1.065,0,0,0-1,1.119V113.4a1.006,1.006,0,1,0,2,0v-4.845A1.065,1.065,0,0,0,342.332,107.434Zm0,0",
    transform: "translate(-313.332 -97.59)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7838-4",
    "data-name": "Path 7838",
    d: "M171.024,94.418a1.065,1.065,0,0,0-1,1.119v9.115a1.006,1.006,0,1,0,2,0V95.537A1.064,1.064,0,0,0,171.024,94.418Zm0,0",
    transform: "translate(-154.024 -86.7)",
    fill: "#7e59d1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaves);
export default __webpack_public_path__ + "static/media/sound-waves.6fdcf3ee2b9b6536f54bb1e291fdf4b0.svg";
export { ForwardRef as ReactComponent };